import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IAmountSpaces } from '../../interfaces/IAmountSpaces';

export type LockerSize = 1 | 2 | 3 | 4 | 5 | 6 | 7;

@Component({
  selector: 'frodo-size-selection',
  templateUrl: './size-selection.component.html',
  styleUrls: ['./size-selection.component.scss'],
})
export class SizeSelectionComponent {
  @Input() availableSizes!: Record<LockerSize, IAmountSpaces>;
  @Output() selected = new EventEmitter<IAmountSpaces>();

  selectSize(sizeSelected: IAmountSpaces): void {
    Object.values(this.availableSizes).forEach((size) => {
      if (size) size.selected = false;
    });

    sizeSelected.selected = true;
    this.selected.emit(sizeSelected);
  }
}
